<script setup lang="ts">
import { format } from 'date-fns'
import { it } from 'date-fns/locale'

const { data } = await useFetch('/api/posts')
const posts = computed(() => {
  const allPosts = data.value?.posts ?? []
  return allPosts
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .slice(0, 3)
})
</script>

<template>
  <section id="testimonianze" class="border-t border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950">
    <UContainer class="py-14 md:py-20">
      <h2 class="text-2xl font-semibold text-slate-900 dark:text-white md:text-3xl">
        Blog
      </h2>
      <p class="mt-3 max-w-2xl text-slate-600 dark:text-slate-300">
        Ultimi post
      </p>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-5">
        <UCard
          v-for="post in posts"
          :key="post.id"
          class="flex flex-col"
        >
          <template #header>
            <div class="-m-6">
              <div class="relative w-full h-48 overflow-hidden rounded-t-lg">
                <img
                  v-if="post.image"
                  :src="post.image"
                  :alt="post.title"
                  class="absolute inset-0 w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                >
                <div
                  v-else
                  class="absolute inset-0 w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                >
                  <UIcon name="i-lucide-image" class="w-12 h-12 text-gray-400" />
                </div>
              </div>
            </div>
          </template>

          <div class="flex-1">
            <h2 class="text-xl font-semibold mb-2">
              {{ post.title }}
            </h2>
            <p class="text-gray-600 dark:text-gray-400 line-clamp-3">
              {{ post.description }}
            </p>
          </div>

          <template #footer>
            <div class="flex justify-between items-center">
              <span class="text-sm text-gray-500">{{
                format(new Date(post.createdAt), 'dd.MM.yyyy', { locale: it })
              }}</span>
              <UButton
                :to="`/blog/${post.slug}`"
                variant="ghost"
                color="primary"
                trailing-icon="i-lucide-arrow-right"
              >
                Leggi di più
              </UButton>
            </div>
          </template>
        </UCard>
      </div>
      <UButton
        to="/blogs"
        variant="ghost"
        color="primary"
        trailing-icon="i-lucide-arrow-right"
        class="mt-5"
      >
        Vai al blog
      </UButton>
    </UContainer>
  </section>
</template>

<style scoped>

</style>
